/* =====================================================
   3-step-custom-form-v2.js
   Combined checkout logic (original) + new v2 UI behavior
   ===================================================== */

// ── Funnel tracking: capture URL parameter on page load ──
(function() {
  var urlParams = new URLSearchParams(window.location.search);
  var funnelSource = urlParams.get('funnel');
  if (funnelSource) {
    sessionStorage.setItem('funnel_source', funnelSource);
  }
})();

// ── Bonus variant capture (e.g. free XL-mat from /pages/tapis-gratuit-offre) ──
// Pattern repris du form FR (3-step-custom-form-v2-bis.js) : si bonus_variant arrive
// en URL ou sessionStorage, on l'ajoute systématiquement au panier avec le Pacha
// au moment du checkout. Sans ça, le cart/clear du form efface tout produit ajouté
// en amont par le CTA "Add to cart" des pages advertorial.
(function() {
  try {
    var fromUrl = new URLSearchParams(window.location.search).get('bonus_variant');
    if (fromUrl && /^\d+$/.test(fromUrl)) {
      sessionStorage.setItem('plfb_bonus_variant', fromUrl);
    }
  } catch (e) {}
})();
var BLOCKED_BONUS_VARIANT = 55568612000120; // XL-mat : offre retiree le 30/07/2026 (cadeau autorise FR et UK uniquement)
function getBonusVariantId() {
  try {
    var fromUrl = new URLSearchParams(window.location.search).get('bonus_variant');
    if (fromUrl && /^\d+$/.test(fromUrl)) {
      var v = parseInt(fromUrl, 10);
      return v === BLOCKED_BONUS_VARIANT ? null : v;
    }
  } catch (e) {}
  try {
    var fromStorage = sessionStorage.getItem('plfb_bonus_variant');
    if (fromStorage && /^\d+$/.test(fromStorage)) {
      var s = parseInt(fromStorage, 10);
      return s === BLOCKED_BONUS_VARIANT ? null : s;
    }
  } catch (e) {}
  return null;
}

// ── Pricing data (hardcoded — does not change via CMS) ──
const catData = {
  1: {
    monthly: 24, quarterly: 67, fullMonthly: 72, savings: 5,
    plan3Detail: '3 zakken elke 12 weken',
    plan1Detail: '1 zak elke 4 weken',
    plan1Price: '24\u20AC'
  },
  2: {
    monthly: 44, quarterly: 122, fullMonthly: 132, savings: 10,
    plan3Detail: '6 zakken elke 12 weken',
    plan1Detail: '2 zakken elke 4 weken',
    plan1Price: '44\u20AC'
  },
  3: {
    monthly: 66, quarterly: 183, fullMonthly: 198, savings: 15,
    plan3Detail: '9 zakken elke 12 weken',
    plan1Detail: '3 zakken elke 4 weken',
    plan1Price: '66\u20AC'
  }
};

let selectedCats = 1;
let selectedPlan = '3mois';
let currentStep = 1;

// ── DOM references (set after DOMContentLoaded) ──
var v2Form, v2FormCard;

// =====================================================
//  ORIGINAL CHECKOUT LOGIC — variant/selling-plan reads
// =====================================================

/**
 * selectOption — called via onclick on .option cards (cat cards in step 1).
 * Keeps the original combinaison-key system intact.
 */
function selectOption(optionSelected, step_number) {
  var container = document.querySelector('.v2-page-wrapper .form-card');
  container.querySelectorAll('.form-step[data-step="' + step_number + '"] .option').forEach(function(option) {
    option.classList.remove('active');
  });
  optionSelected.classList.add('active');
  updateCurrentSelectedOffer();
}

/**
 * Read active .option cards from step1 + step2,
 * combine their combinaison keys, and set the matching .issue span to active.
 */
function updateCurrentSelectedOffer() {
  var activeOptions = document.querySelectorAll('.v2-page-wrapper .option.active');
  if (activeOptions.length < 2) return;
  var first_key = activeOptions[0].dataset.combinaisonKey;
  var second_key = activeOptions[1].dataset.combinaisonKey;
  document.querySelectorAll('.v2-page-wrapper .issue').forEach(function(issue) {
    if (issue.dataset.combinaisonKey === first_key + second_key) {
      issue.classList.add('active');
    } else {
      issue.classList.remove('active');
    }
  });
}

function getCurrentSelectedOfferID() {
  var el = document.querySelector('.v2-page-wrapper .issue.active');
  return el ? parseInt(el.dataset.variantId) : null;
}

function getCurrentSelectedOfferPlanID() {
  var el = document.querySelector('.v2-page-wrapper .issue.active');
  return el ? parseInt(el.dataset.sellingplanId) : null;
}

// =====================================================
//  POPUP
// =====================================================

var _popupPreviousFocus = null;

/* 21/09/2026 — voie de paiement choisie par le client : 'ideal' (iDEAL/Bancontact) ou 'carte'.
   takeOffer() se terminait par doCheckout() en dur : le client qui cliquait iDEAL puis acceptait
   le plan 3 mois dans la fenêtre de rétention se retrouvait sur le checkout carte, sans iDEAL. */
var _ckRail = null;   // 'ideal' | 'carte' | null tant qu'aucun bouton de paiement n'a ete clique

/* Plans « jumeaux » Juo (achat ponctuel) : iDEAL et Bancontact refusent le prélèvement récurrent.
   Le plan jumeau porte parent:<plan récurrent> dans ses options et Juo recrée l'abonnement à
   partir de la propriété de ligne _selling_plan_id. Relevé sur le store le 21/09/2026 via
   /?section_id=juo-selling-plans : prix identiques au tunnel carte, remise trimestrielle gardée. */
var JUO_FIXED_PLAN = {
  '711572324728': 711964885368,
  '711822573944': 711965016440
};

/* Même chemin que le bouton iDEAL, mais déclenché depuis la fenêtre de rétention.
   On ne passe pas par le script Juo : il ne se câble pas toujours au moment où on en a besoin.
   Repli sur le tunnel carte si le plan jumeau manque ou si le panier refuse. */
function doCheckoutIdeal() {
  if (_checkoutInProgress) return;
  var items = _buildCartItems();
  var rec = getCurrentSelectedOfferPlanID();
  var fixed = (items && rec) ? JUO_FIXED_PLAN[String(rec)] : null;
  if (!items || !fixed) { doCheckout(); return; }
  items[0].selling_plan = fixed;
  items[0].properties = { '_selling_plan_id': String(rec) };
  _checkoutInProgress = true;
  fetch(window.Shopify.routes.root + 'cart/clear.js', {
    method: 'POST', headers: { 'Content-Type': 'application/json' }
  })
    .then(function() {
      return fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      });
    })
    .then(function(response) {
      if (!response.ok) throw new Error('cart-add-failed');
      return response.json();
    })
    .then(function(data) {
      if (!data.items || data.items.length === 0) throw new Error('cart-add-failed');
      var funnelSource = sessionStorage.getItem('funnel_source');
      if (funnelSource) {
        return fetch('/cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: 'funnel_source=' + funnelSource })
        }).catch(function() {});
      }
    })
    .then(function() { location.href = '/checkout?skip_shop_pay=true'; })
    .catch(function() { _checkoutInProgress = false; doCheckout(); });
}

function showPopup() {
  _popupPreviousFocus = document.activeElement;
  var overlay = document.getElementById('v2-popup-overlay');
  overlay.classList.add('visible');
  // Mark .next-checkout so checkoutButton's safety-net popup trigger does not re-fire
  // after the user closes the popup (the popup may have been opened via selectPlan).
  var nextBtn = document.querySelector('.next-checkout');
  if (nextBtn) nextBtn.classList.add('popupTriggered');
  // Move focus to first actionable button inside popup
  var firstBtn = overlay.querySelector('.popup-btn-keep');
  if (firstBtn) setTimeout(function() { firstBtn.focus(); }, 100);
}

function closePopup() {
  document.getElementById('v2-popup-overlay').classList.remove('visible');
  // Return focus to element that triggered the popup
  if (_popupPreviousFocus) {
    _popupPreviousFocus.focus();
    _popupPreviousFocus = null;
  }
}

// ESC key closes popup
document.addEventListener('keydown', function(e) {
  if ((e.key === 'Escape' || e.keyCode === 27) && document.getElementById('v2-popup-overlay').classList.contains('visible')) {
    closePopup();
  }
});

// Focus trap inside popup
document.addEventListener('keydown', function(e) {
  if (e.key !== 'Tab' && e.keyCode !== 9) return;
  var overlay = document.getElementById('v2-popup-overlay');
  if (!overlay || !overlay.classList.contains('visible')) return;
  var modal = overlay.querySelector('.popup-modal');
  var focusable = modal.querySelectorAll('button, [href], input, [tabindex]:not([tabindex="-1"])');
  if (focusable.length === 0) return;
  var first = focusable[0];
  var last = focusable[focusable.length - 1];
  if (e.shiftKey) {
    if (document.activeElement === first) { e.preventDefault(); last.focus(); }
  } else {
    if (document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
});

/**
 * "Choisir le plan 3 mois" button in popup:
 * 1. Select the 3mois option
 * 2. Update active classes + combinaison
 * 3. Proceed to checkout
 */
function takeOffer() {
  closePopup();
  selectedPlan = '3mois';
  applyPlanUI();
  // Click the 3mois hidden .option to update combinaison
  var plan3Option = document.querySelector('.v2-page-wrapper .option[data-combinaison-key="3mois"]');
  if (plan3Option) {
    plan3Option.classList.add('active');
    // Remove active from 1mois option
    var plan1Option = document.querySelector('.v2-page-wrapper .option[data-combinaison-key="1mois"]');
    if (plan1Option) plan1Option.classList.remove('active');
    updateCurrentSelectedOffer();
  }
  if (_ckRail === 'ideal') { doCheckoutIdeal(); return; }
  if (_ckRail === 'carte') { doCheckout(); return; }
  /* La fenetre s'est ouverte au choix du plan mensuel, donc AVANT tout choix de paiement :
     on ne tranche pas a la place du client. Le plan passe a 3 mois, la fenetre se ferme, et
     les deux boutons restent sous ses yeux. Sans bouton iDEAL (autres marches), une seule
     voie existe : on part au paiement comme avant. */
  var idealBtn = document.getElementById('juo-static-checkout-link');
  if (idealBtn) { try { idealBtn.focus(); } catch (e) {} return; }
  doCheckout();
}

/**
 * "Continuer avec le plan mensuel" button in popup:
 * Close popup — 1mois is already selected (Test #3 behavior).
 */
function continue1Month() {
  closePopup();
  // 1mois stays selected, user can click Paiement again to proceed
}

// Lock to prevent double-click triggering parallel cart operations.
// Released on bfcache restore (user navigates back from /checkout).
var _checkoutInProgress = false;
window.addEventListener('pageshow', function() {
  _checkoutInProgress = false;
});

/**
 * Build the cart items array from the currently selected offer.
 * Returns null if no valid variant is selected.
 */
function _buildCartItems() {
  var variantId = getCurrentSelectedOfferID();
  if (!variantId || isNaN(variantId)) return null;
  var sellingPlanId = getCurrentSelectedOfferPlanID();
  var item = { 'id': variantId, 'quantity': 1 };
  if (sellingPlanId && !isNaN(sellingPlanId)) item['selling_plan'] = sellingPlanId;
  var items = [item];
  var bonusId = getBonusVariantId();
  if (bonusId) items.push({ 'id': bonusId, 'quantity': 1 });
  return items;
}

/**
 * Clear + add cart with the current selection, optionally append funnel note,
 * then return the fresh cart object. Used by both doCheckout (self-redirects)
 * and checkoutWithNoUpsell (Juo path, no self-redirect).
 */
function _populateCart() {
  var items = _buildCartItems();
  if (!items) return Promise.reject(new Error('no-variant'));
  return fetch(window.Shopify.routes.root + 'cart/clear.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' }
  })
    .then(function() {
      return fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      });
    })
    .then(function(response) {
      if (!response.ok) throw new Error('cart-add-failed');
      return response.json();
    })
    .then(function(data) {
      if (!data.items || data.items.length === 0) throw new Error('cart-add-failed');
      var funnelSource = sessionStorage.getItem('funnel_source');
      if (funnelSource) {
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: 'funnel_source=' + funnelSource })
        }).catch(function() {});
      }
    })
    .then(function() {
      // Re-fetch the full cart so callers (Juo) get selling_plan_allocation populated.
      return fetch('/cart.js', { headers: { 'cache': 'no-store' } }).then(function(r) { return r.json(); });
    });
}

/**
 * checkoutWithNoUpsell — invoked by the Juo button via window.checkoutFunctions.
 * Juo calls it with `false` and AWAITS the returned cart so it can map the
 * Shopify selling_plan_allocation to its own Juo selling_plan_id, then redirect
 * to /checkout?skip_shop_pay=true itself. We must NOT self-redirect in that flow.
 */
function checkoutWithNoUpsell(redirect) {
  if (redirect === undefined) redirect = true;
  if (_checkoutInProgress) return Promise.resolve(null);
  _checkoutInProgress = true;

  return _populateCart()
    .then(function(cart) {
      if (redirect) {
        location.href = '/checkout';
      } else {
        // Releasing only on the no-redirect path — Juo will redirect right after.
        _checkoutInProgress = false;
      }
      return cart;
    })
    .catch(function(err) {
      _checkoutInProgress = false;
      if (err && err.message === 'no-variant') {
        alert('Fout: product niet gevonden. Vernieuw de pagina en probeer het opnieuw.');
      }
      return null;
    });
}

/**
 * Safety net: if the user reaches step 2 with the 1mois plan active without
 * having seen the popup (e.g. deep link `?step2_option=1mois`), intercept the
 * first checkout click and show the popup once. Once `popupTriggered` is set
 * on `.next-checkout` (either here or by showPopup() itself), this no-ops.
 */
function checkoutButton(e, button) {
  var popup_id = '1mois';
  var nextBtn = document.querySelector('.next-checkout');
  if (!nextBtn || nextBtn.classList.contains('popupTriggered')) return;
  var step2Options = document.querySelectorAll('.v2-page-wrapper .option[data-step="2"]');
  var matched = false;
  step2Options.forEach(function(opt) {
    if (opt.classList.contains('active') && opt.dataset.combinaisonKey === popup_id) {
      matched = true;
    }
  });
  if (matched) {
    showPopup();
    e.preventDefault();
    e.stopImmediatePropagation();
  }
}

function doCheckout(redirect = true) {
  if (_checkoutInProgress) return;
  _checkoutInProgress = true;

  _populateCart()
    .then(function() {
      if (redirect) {
        location.href = '/checkout';
      } else {
        _checkoutInProgress = false;
      }
    })
    .catch(function(err) {
      _checkoutInProgress = false;
      if (err && err.message === 'no-variant') {
        alert('Fout: product niet gevonden. Vernieuw de pagina en probeer het opnieuw.');
      } else {
        alert('Fout bij het toevoegen aan winkelwagen. Vernieuw de pagina en probeer het opnieuw.');
      }
    });
}

/**
 * checkout — called when user clicks "Paiement" button.
 * In v2, the popup is triggered on selectPlan('1mois') instead,
 * so this function goes straight to checkout.
 */
function checkout(popup_id, redirect = true) {
  doCheckout(redirect);
}

// Expose checkout functions globally for Juo integration
window.checkoutFunctions = {
  checkout: checkout,
  checkoutWithNoUpsell: checkoutWithNoUpsell
};

// =====================================================
//  V2 UI BEHAVIOR
// =====================================================

/**
 * selectCat — Step 1 cat card click
 */
function selectCat(n) {
  selectedCats = n;
  /* meme piege que pour le plan : le nombre de chats est un radio, on resynchronise */
  var rc = document.getElementById('cat-' + n);
  if (rc) rc.checked = true;
  // Update visual selection on cat-option cards
  document.querySelectorAll('.v2-page-wrapper .cat-option').forEach(function(el, i) {
    el.classList.toggle('selected', i === n - 1);
  });
  // Also update the hidden .option active state for step 1
  var step1Options = document.querySelectorAll('.v2-page-wrapper .option[data-step="1"]');
  step1Options.forEach(function(el, i) {
    el.classList.toggle('active', i === n - 1);
  });
  updateCurrentSelectedOffer();
  updateDisplay();
}

/**
 * selectPlan — Step 2 plan card click.
 * Test #3: If user clicks 1mois when 3mois was selected, show popup after a short delay.
 */
function selectPlan(plan) {
  if (plan === '1mois' && selectedPlan === '3mois') {
    selectedPlan = '1mois';
    applyPlanUI();
    // Update hidden .option for step 2
    syncStep2Option('1mois');
    updateCurrentSelectedOffer();
    // Short delay so user sees selection applied before popup
    setTimeout(function() { showPopup(); }, 350);
    return;
  }
  selectedPlan = plan;
  applyPlanUI();
  syncStep2Option(plan);
  updateCurrentSelectedOffer();
}

function syncStep2Option(plan) {
  var step2Options = document.querySelectorAll('.v2-page-wrapper .option[data-step="2"]');
  step2Options.forEach(function(el) {
    if (el.dataset.combinaisonKey === plan) {
      el.classList.add('active');
    } else {
      el.classList.remove('active');
    }
  });
}

function applyPlanUI() {
  var plan3Card = document.getElementById('plan-3mois');
  var plan1Card = document.getElementById('plan-1mois');
  if (plan3Card) plan3Card.classList.toggle('selected', selectedPlan === '3mois');
  if (plan1Card) plan1Card.classList.toggle('selected', selectedPlan === '1mois');
  /* 22/09/2026 — le choix du plan est un vrai <input type="radio"> qui appelle selectPlan()
     par son onchange. On ne touchait que la classe .selected : apres un refus dans la fenetre
     de retention puis un retour a l'etape 1, l'affichage repassait sur 3 mois alors que le
     radio « 1 maand » restait coche. Le clic suivant n'emettait donc AUCUN change et la
     selection ne repondait plus (il fallait passer par 3 mois pour la debloquer). */
  var r3 = document.getElementById('plan-radio-3mois');
  var r1 = document.getElementById('plan-radio-1mois');
  if (r3) r3.checked = (selectedPlan === '3mois');
  if (r1) r1.checked = (selectedPlan === '1mois');
}

function updateDisplay() {
  var d = catData[selectedCats];
  if (!d) return;

  var savingsTag = document.getElementById('savings-tag');
  var plan3Old = document.getElementById('plan3-price-old');
  var plan3New = document.getElementById('plan3-price-new');
  var plan3Detail = document.getElementById('plan3-detail');
  var plan3Footer = document.getElementById('plan3-footer');
  var plan1Price = document.getElementById('plan1-price');
  var plan1Detail = document.getElementById('plan1-detail');
  var popupDeliverySavings = document.getElementById('popup-delivery-savings');
  var step2Context = document.getElementById('step2-context');

  if (savingsTag) savingsTag.textContent = 'Bespaar \u20AC ' + d.savings;
  if (plan3Old) plan3Old.textContent = '\u20AC ' + d.fullMonthly;
  if (plan3New) plan3New.textContent = '\u20AC ' + d.quarterly;
  if (plan3Detail) plan3Detail.textContent = d.plan3Detail;
  if (plan3Footer) plan3Footer.textContent = '\u20AC ' + d.savings + ' korting!';
  if (plan1Price) plan1Price.textContent = d.plan1Price;
  if (plan1Detail) plan1Detail.textContent = d.plan1Detail;
  if (popupDeliverySavings) popupDeliverySavings.textContent = 'Bespaar \u20AC ' + d.savings + ' per 3 maanden';

  var catLabel = selectedCats === 1 ? '1 kat' : selectedCats + ' katten';
  if (step2Context) step2Context.textContent = 'Uw aanbieding voor ' + catLabel;

  // Per-cat/month cost — only show for 2+ cats
  var perCatEl = document.getElementById('plan3-per-cat');
  if (perCatEl) {
    if (selectedCats >= 2) {
      var perCat = (d.quarterly / 3 / selectedCats).toFixed(2).replace('.', ',');
      perCatEl.textContent = '~ \u20AC ' + perCat + '/kat/maand';
      perCatEl.style.display = '';
    } else {
      perCatEl.style.display = 'none';
    }
  }
}

/**
 * goToStep — Navigate between steps.
 * When entering step 2, pre-select 3mois.
 */
function goToStep(step) {
  currentStep = step;
  document.querySelectorAll('.v2-page-wrapper .form-step').forEach(function(el) {
    el.classList.remove('active');
  });
  var target = document.getElementById('step-' + step);
  if (target) target.classList.add('active');

  // Update progress bar
  document.querySelectorAll('.v2-page-wrapper .step-container').forEach(function(el, i) {
    el.classList.remove('active', 'done');
    if (i < step - 1) el.classList.add('done');
    if (i === step - 1) el.classList.add('active', 'done');
  });

  // Reset to 3mois when entering step 2
  if (step === 2) {
    selectedPlan = '3mois';
    applyPlanUI();
    syncStep2Option('3mois');
    updateCurrentSelectedOffer();
    updateDisplay();
  }

  window.scrollTo({ top: 0, behavior: 'smooth' });
}

// =====================================================
//  DEEP LINKING (fromURL — preserved from original)
// =====================================================

function fromURL() {
  var queryString = window.location.search;
  var urlParams = new URLSearchParams(queryString);
  var step = urlParams.get('step');
  var step1_option = urlParams.get('step1_option');
  var step2_option = urlParams.get('step2_option');

  if (step != null) {
    goToStep(parseInt(step));
  }

  if (step1_option != null) {
    var idx = parseInt(step1_option);
    if (idx >= 1 && idx <= 3) {
      selectCat(idx);
    }
  }

  if (step2_option != null) {
    if (step2_option === '1' || step2_option === '1mois') {
      selectPlan('1mois');
    } else if (step2_option === '2' || step2_option === '3mois') {
      selectPlan('3mois');
    }
  }
}

// =====================================================
//  FAQ
// =====================================================

function toggleFaq(btn) {
  var item = btn.closest('.faq-item');
  item.classList.toggle('open');
  var isOpen = item.classList.contains('open');
  btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
}

// =====================================================
//  REVIEWS CAROUSEL
// =====================================================

var reviewTrack, reviewCards, dotsContainer;
var currentReview = 0;
var reviewTimer;

function initReviews() {
  reviewTrack = document.getElementById('reviews-track');
  dotsContainer = document.getElementById('review-dots');
  if (!reviewTrack || !dotsContainer) return;
  reviewCards = reviewTrack.children;

  // Build dots
  for (var i = 0; i < reviewCards.length; i++) {
    var dot = document.createElement('span');
    dot.className = 'review-dot' + (i === 0 ? ' active' : '');
    (function(idx) {
      dot.onclick = function() { goToReview(idx); };
    })(i);
    dotsContainer.appendChild(dot);
  }

  resetReviewTimer();
}

function goToReview(index) {
  currentReview = index;
  if (reviewTrack) {
    reviewTrack.style.transform = 'translateX(-' + (index * 100) + '%)';
  }
  if (dotsContainer) {
    dotsContainer.querySelectorAll('.review-dot').forEach(function(d, i) {
      d.classList.toggle('active', i === index);
    });
  }
  resetReviewTimer();
}

function reviewNav(dir) {
  if (!reviewCards) return;
  var next = currentReview + dir;
  if (next < 0) next = reviewCards.length - 1;
  if (next >= reviewCards.length) next = 0;
  goToReview(next);
}

function resetReviewTimer() {
  clearInterval(reviewTimer);
  reviewTimer = setInterval(function() {
    reviewNav(1);
  }, 5000);
}

// =====================================================
//  STICKY CTA
// =====================================================

function initStickyCta() {
  var stickyCta = document.getElementById('v2-sticky-cta');
  var formCard = document.querySelector('.v2-page-wrapper .form-card');
  if (!stickyCta || !formCard) return;

  window.addEventListener('scroll', function() {
    var formBottom = formCard.getBoundingClientRect().bottom;
    stickyCta.classList.toggle('visible', formBottom < 0);
  });
}

// =====================================================
//  INITIALIZATION
// =====================================================

function initV2Form() {
  // Set step 1 cat option 1 as active (default)
  var step1Options = document.querySelectorAll('.v2-page-wrapper .option[data-step="1"]');
  if (step1Options.length > 0) step1Options[0].classList.add('active');

  // Set step 2 3mois option as active (pre-selected)
  var step2Options = document.querySelectorAll('.v2-page-wrapper .option[data-step="2"]');
  step2Options.forEach(function(el) {
    if (el.dataset.combinaisonKey === '3mois') {
      el.classList.add('active');
    }
  });

  // Set first cat-option card as selected
  var catOptions = document.querySelectorAll('.v2-page-wrapper .cat-option');
  if (catOptions.length > 0) catOptions[0].classList.add('selected');

  // Update combinaison
  updateCurrentSelectedOffer();

  // Update display with default cat count
  updateDisplay();

  // Apply plan UI (3mois pre-selected)
  applyPlanUI();

  // Init sub-features
  initReviews();
  initStickyCta();

  // Bind checkout buttons — exact same pattern as v1 get-started page
  var checkoutBtns = document.querySelectorAll('#juo-static-checkout-link, .next-checkout');
  checkoutBtns.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      _ckRail = (btn.id === 'juo-static-checkout-link') ? 'ideal' : 'carte';
      checkoutButton(e, btn);
    }, true);
  });

  var regularBtns = document.querySelectorAll('.next-checkout');
  regularBtns.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      checkout('1mois');
    }, true);
  });

  // Deep linking
  fromURL();
}

// Run when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initV2Form);
} else {
  initV2Form();
}
